import { useId } from "react";

import { DiagramFrame } from "@/app/features/diagrams/components/shared/DiagramFrame";
import { WorkManagementDrawing } from "@/app/features/diagrams/components/blog/workManagement/WorkManagementDrawing";

export function WorkManagementLifecycleVisual() {
  const id = useId();

  return (
    <DiagramFrame
      width={860}
      height={560}
      title="Task management: work, holds, and review"
      description="Two tasks share the same workflow. Ready tasks start with an owner and can return to the queue through an acknowledged handoff. Task B waits on a recorded blocker until cleared. Task A is submitted for human or AI review, returns to its owner if rejected, and closes only after approval. Task C is cancelled with its outcome recorded."
      titleId={`${id}-title`}
      descId={`${id}-description`}
      viewBox="0 0 860 560"
      frame={{
        kind: "boundary",
        label: "TASK MANAGEMENT: WORK, HOLDS & REVIEW",
        x: 18,
        y: 24,
        width: 824,
        height: 520,
      }}
    >
      <WorkManagementDrawing markerPrefix="wml-" />
    </DiagramFrame>
  );
}
